import React from 'react';
import {
  FormControlLabel,
  Input,
  Select,
  MenuItem,
  ListItemText,
  Checkbox,
} from '@mui/material';
import PropTypes from 'prop-types';

import { MenuProps } from '../../Assets/js/constant';

function YearSelector({
  selectedYears,
  label,
  onChange
}) {
  const handleChange = (event) => {
    const all = 'All';
    const newYears = event.target.value;

    let years = ['All'];
    let current_year = new Date().getFullYear();
    for (var i = current_year - 4; i <= current_year + 1; i++) {
      years.push(i);
    }

    let _selectedYears = [],
      _label;

    if (selectedYears.indexOf(all) > -1) {
      if (newYears.indexOf(all) > -1) {
        newYears.splice(newYears.indexOf(all), 1);
        _selectedYears = newYears;
        _label = 'Multi';
      } else {
        _selectedYears = [];
        _label = 'None';
      }
    } else {
      if (newYears.indexOf(all) > -1) {
        _selectedYears = years;
        _label = 'All';
      } else {
        if (newYears.length === years.length - 1) {
          _selectedYears = years;
          _label = 'All';
        } else {
          _selectedYears = newYears;
          if (newYears.length > 1) {
            _label = 'Multi';
          } else if (newYears.length === 1) {
            _label = newYears[0].toString();
          } else {
            _label = 'None';
          }
        }
      }
    }

    onChange({
      selectedYears: _selectedYears,
      label: _label,
    });
  };

  let years = ['All'];
  let current_year = new Date().getFullYear();
  for (var i = current_year - 4; i <= current_year + 1; i++) {
    years.push(i);
  }

  return (
    <div className="border">
      <FormControlLabel
        sx={{
          marginLeft: '0px !important',
          minWidth: 102,
          maxWidth: 300,
          '& .MuiTypography-body1': {
            fontWeight: 'bold',
            fontFamily: 'Verdana !important',
            fontSize: '10pt',
          },
        }}
        control={
          <Select
            multiple
            sx={{
              marginLeft: 5,
              marginRight: 20,
              '& .MuiSelect-selectMenu': {
                padding: '6.5px 24px 6.5px 0',
                fontWeight: 'bold',
                fontFamily: 'Verdana !important',
                fontSize: '10pt',
              },
            }}
            value={selectedYears.length !== 0 ? selectedYears : []}
            onChange={handleChange}
            input={<Input className="select-multiple-checkbox" />}
            renderValue={(selected) => label}
            MenuProps={MenuProps}
          >
            {years &&
              years.map((year) => (
                <MenuItem
                  key={year}
                  value={year}
                  sx={{
                    padding: '2px 5px',
                  }}
                >
                  <Checkbox
                    className="pd-0"
                    checked={selectedYears.indexOf(year) > -1}
                    color="success"
                  />
                  <ListItemText primary={year} />
                </MenuItem>
              ))}
          </Select>
        }
        label="FY : "
        labelPlacement="start"
      />
    </div>
  );
}

YearSelector.propTypes = {
  selectedYears: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default YearSelector;
